import * as angular from "angular";
import "./hideOnIE.scss";

export class HideOnIe implements angular.IDirective {

    restrict = "A";
    terminal = true;
    priority = 599; // One less than ng-if to allow ng-if to happen first

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor($compile: angular.ICompileService) {
        HideOnIe.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {
            
            // Do this if we need to test for IE11 specifically
            var isIE = /MSIE|Trident|Edge/.test(window.navigator.userAgent);
            
            var isIE11 = !!window["MSInputMethodContext"] && !!document["documentMode"];

            if (isIE) {
                $element.html(`<div class="hide-on-ie">
                                <div class="line-1">This feature is not available on this browser</div>
                                <div class="line-2">Please try <a href="https://www.google.com/chrome">Chrome</a> or <a href="https://www.mozilla.org/firefox/">Firefox</a></div>
                                </div>`);
            }
            else {
                $element.removeAttr("hide-on-ie");
                $compile($element)($scope);
            }
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($compile: angular.ICompileService) => new HideOnIe($compile);

        directive.$inject = ["$compile"];

        return directive;
    }
}
